export default{
    apiBaseURL : process.env.BASE_API_URL,
    managementBaseURL : process.env.BASE_API_MANAGEMENT,
    apiAuthBaseUrl: process.env.BASE_API_AUTH_URL,

    apiLocalURL : '/json/',

    phonePicturesRoute: 'https://developer.suivideflotte.net/smartphones/{hash}',

    apiVersion: 1,

    endpoints: {
        attachment:{
            vocal:'beepiz/vocal'
        },
        oauth: {
            login: 'api/users/login',
            google: 'api/oauth2/sso/google',
            microsoft: 'api/oauth2/sso/graph',
            logout: 'oauth2/logout',
            refresh: 'api/users/refresh',
            forget: 'forget-password',
            resetPassword: '/forget-password/reset',
            checkResetDuration: '/check-reset-duration'
        },

        public: {
            channelConfirmation: 'beepiz/channel-confirmation',
            temporaryWatchman: 'beepiz/temporarywatchmen/confirm/{unique_id}',
            temporaryWatchmanConfirm: 'beepiz/temporarywatchmen/confirmwatchmen',
        },

        user: {
            connected: 'me',
            acl: 'me/acl',
            changePassword: 'me/user/infos',
            client: 'me/client/infos',
            settings: '/beepiz/user/settings',
            //connected: 'user/user.json'
        },

        users: {
            index: 'beepiz/users',
            import: '/beepiz/import-excel-invitation-file'
        },

        plans: {
            index: 'beepiz/plans',
            show: 'beepiz/plans/{planId}',
            getImage: 'beepiz/plans/{planId}/getimage',
            add: 'beepiz/plans',
            edit: 'beepiz/plans/{planId}',
            delete: 'beepiz/plans/{planId}',
            order: 'beepiz/plans/{planId}/treeposition',
            apAddToPlan: 'beepiz/plans/{planId}/actionpoints/{apId}',
            apPlacement: 'beepiz/plans/{planId}/actionpoints/{apId}/location',
            apDelete: 'beepiz/plans/{planId}/actionpoints/{apId}/location',
            addZone: 'beepiz/plans/{planId}/groups',
            editZone: 'beepiz/plans/{planId}/groups',
            deleteZone: 'beepiz/plans/{planId}/groups',
            orderAP: 'beepiz/plans/{planId}/actionpoints/{apId}/treeposition',
            apAvailable: 'beepiz/plans/{planId}/actionpoints/available',
            geocoding: 'services/geocoding?address='
        },

        actionpoints: {
            index: 'beepiz/actionpoints',
            show: 'beepiz/actionpoints/{apId}',
            add: 'beepiz/actionpoints',
            edit: 'beepiz/actionpoints/{apId}',
            delete: 'beepiz/actionpoints/{apId}',
        },

        plansActionpoints: {
            index: 'beepiz/plans/{planId}/actionpoints',
        },

        identifications: {
            index: 'beepiz/identifications',
            show: 'beepiz/identifications/{id}',
            add: 'beepiz/identifications',
            edit: 'beepiz/identifications/{id}',
            delete: 'beepiz/identifications/{id}',
        },

        licences:{
            //index: 'licences.json',
            index: 'beepiz/registrations',
            add: 'beepiz/registrations',
            resend: 'beepiz/registrations/{hash}',
            delete: 'beepiz/registrations/{hash}',
            import: '/beepiz/import-excel-invitation-file',
            errorLogImport: '/beepiz/download-error-import',
            export: '/beepiz/download-excel-file-model',
            mass: {
                cancel: 'beepiz/cancelregistration',
                resend: 'beepiz/reflateregistration',
                cancel_details: 'beepiz/cancelregistrationdetails',
                resend_details: 'beepiz/reflateregistrationdetails'
            }
        },

        // profils / Groupes
        profiles: {
            index: 'beepiz/profiles',
            index2: 'beepiz/user-manager/user-profiles',
            show: 'beepiz/profiles/{profileId}',
            addOrEdit: 'beepiz/profiles',
            delete: 'beepiz/profiles/{profileId}',
            kpi: 'beepiz/profiles/{profileId}/kpi'
        },
        groups: {
            index: 'beepiz/groups',
            index2: 'beepiz/user-manager/user-groups',
            show: 'beepiz/groups/{groupId}',
            add: 'beepiz/groups',
            edit: 'beepiz/groups/{groupId}',
            delete: 'beepiz/groups/{groupId}',
            datis: 'beepiz/groups/{groupId}/datis'
        },

        planning: {
            index: 'beepiz/plannings',
            show: 'beepiz/plannings/{planningId}',
            addOrEdit: 'beepiz/plannings',
            delete: 'beepiz/plannings/{planningId}'
        },

        tos: {
            show: 'beepiz/cgu/getlatestversion',
            edit: 'beepiz/cgu/createorupdate'
        },

        phonebooks: {
            index: 'beepiz/phonebooks',
            show: 'beepiz/phonebooks/{bookId}',
            add: 'beepiz/phonebooks',
            edit: 'beepiz/phonebooks/{bookId}',
            delete: 'beepiz/phonebooks/{bookId}',
            contacts: {
                index: 'beepiz/phonebooks/{bookId}/contacts',
                add: 'beepiz/phonebooks/{bookId}/contacts',
                edit: 'beepiz/phonebooks/{bookId}/contacts/{contactId}',
                delete: 'beepiz/phonebooks/{bookId}/contacts/{contactId}',
                order: 'beepiz/phonebooks/{bookId}/contacts/order',
            },
        },

        ppes: {
            index: '/beepiz/ppes/lists',
            show: '/beepiz/ppes/lists/{id}',
            add: 'beepiz/ppes/lists',
            edit: '/beepiz/ppes/lists/{id}',
            delete: '/beepiz/ppes/lists/{id}',
            items: '/beepiz/ppes/items'
        },

        datis: {
            picture: 'https://developer.suivideflotte.net/smartphones/{hash}',
            index: 'beepiz/datis',
            show: 'beepiz/datis/{id}',
            edit: 'beepiz/datis/{id}',
            indexByGroup: 'beepiz/datis/bygroup',
            newIndexByGroup: 'beepiz/datis/newbygroup',
            delete: 'beepiz/datis/{id}/registrations',
            status: 'beepiz/datis/{id}/state',
            monitoring: 'beepiz/datistate',
            notifications: 'beepiz/notifications',
            notificationsItem: 'beepiz/notifications/{id}',
            licencesExport: 'beepiz/exportlicencestoexcel',
            assignGroupProfil: 'beepiz/user-manager/assign-group-profil',
            endLostComSessions: 'beepiz/endLostComSessions',
            export: 'beepiz/datis/export'
        },

        dashboard: {
            widgets: 'widgets/dashboard/beepiz',
            messageSite: 'api/message_site'
        },

        reports: {
            index: 'reports/reports.json',
            activity: 'beepiz/reports/activity/{resourceType}-{resourceId}/{reportPeriod}',
            usage: 'beepiz/reports/usage/{resourceType}-{resourceId}/{reportPeriod}',
            alerts: 'beepiz/reports/alert/{resourceType}-{resourceId}/{reportPeriod}',
            patrol: 'beepiz/reports/patrol/{resourceType}-{resourceId}/{reportPeriod}?patrolid={patrolId}&zoom={zoom}',
            alertrecord: 'beepiz/reports/alertrecord/alert-{alertId}/{reportPeriod}',
            ppes: 'beepiz/reports/ppes/{resourceType}-{resourceId}/{reportPeriod}',
            actionpoint: 'beepiz/reports/actionpoint/actionpoint-{resourceId}/{reportPeriod}',
            resources: {
                dati: 'beepiz/datis/bygroup',
                identification: 'beepiz/identifications'
            },
            licence: 'beepiz/reports/licence',
            profile: 'beepiz/reports/profile'
        },


        patrols: {
            index: 'beepiz/patrols',
            show: 'beepiz/patrols/{patrolId}',
            add: 'beepiz/patrols',
            edit: 'beepiz/patrols/{patrolId}',
            delete: 'beepiz/patrols/{patrolId}',
            start: 'beepiz/patrols/{patrolId}/start?resourceType={resourceType}&resourceId={resourceId}&date={date}',
            compare: 'beepiz/patrols/{patrolId}/compare?resourceType={resourceType}&resourceId={resourceId}&date={date}&theoricStart={theoricDate}',
            listing: 'beepiz/patrols-listing',
            listingExport: 'beepiz/patrols-listing-export'
        },

        contacts: {
            add: 'beepiz/remotemonitoring/contacts',
            call: 'beepiz/remotemonitoring/validation-contact/{contactId}',
            index: 'beepiz/remotemonitoring/contacts'
        },

        remoteMonitoring: {
            logs: 'beepiz/remotemonitoring/{providerId}/logs',
            index:'beepiz/remotemonitoring/procedures',
            show: 'beepiz/remotemonitoring/procedures/{procedureId}',
            update: 'beepiz/remotemonitoring/procedures/{procedureId}',
            create:'beepiz/remotemonitoring/procedures',
            delete:'beepiz/remotemonitoring/procedures/{procedureId}'
        },

        alerts: {
            index: 'beepiz/alerts',
            dismiss: 'beepiz/alerts/{id}'
        },

        news: {
            list: 'editorialcontent/whatsnew/beepiz'
        },

        watchmen: {
            index: 'beepiz/watchmen',
            show: 'beepiz/watchmen/{watchmanId}',
            add: 'beepiz/watchmen',
            edit: 'beepiz/watchmen/{watchmanId}',
            delete: 'beepiz/watchmen/{watchmanId}',
            merge: 'beepiz/watchmen/merge',
        },

        channels: {
            index: 'beepiz/channels',
            show: 'beepiz/channels/{channelId}',
            add: 'beepiz/channels',
            edit: 'beepiz/channels/{channelId}',
            delete: 'beepiz/channels/{channelId}',
            validate: 'beepiz/channels/validation/{channelId}',
        },

        certificate:{
            index: 'beepiz/certificate'
        },

        permissions: {
            flag: 'api/features-flags'
        },

    hazard_reporting: {
      new_count: "api/hazard-reporting/kpi/new",
    },
    },

    route: function(route,params){
        var finalRoute = route;
        for(var paramKey in params){
            finalRoute = finalRoute.replace('{'+paramKey+'}',params[paramKey]);
        }
        return finalRoute;
    },
    constructQueryParams: function(options) {
        // Sécurité : si options est null ou undefined, on crée un objet vide
        var opt = options || {};
        var queryArray = [];

        if(opt.fields != null && opt.fields.length > 0){
            queryArray.push(this._constructQueryParamArrayFragment('fields', opt.fields));
        }

        if(opt.perpage){
            queryArray.push(this._constructQueryParamFragment('perpage', opt.perpage));
        }

        if(opt.page){
            queryArray.push(this._constructQueryParamFragment('page', opt.page));
        }

        if(opt.filter != null && opt.filter.equals != null && opt.filter.equals.length > 0){
            queryArray.push(this._constructQueryParamArrayFragment('equals', opt.filter.equals));
        }

        if(opt.filter != null && opt.filter.like != null && opt.filter.like.length > 0){
            queryArray.push(this._constructQueryParamArrayFragment('like', opt.filter.like));
        }

        if(opt.sort != null && opt.sort.length > 0){
            queryArray.push(this._constructQueryParamArrayFragment('sort', opt.sort).replace(/\+/g,''));
        }

        if(opt.type != null && opt.type.length > 0){
            queryArray.push(this._constructQueryParamArrayFragment('type', opt.type));
        }

        return '?' + queryArray.join('&');
    },
    _constructQueryParamFragment: function(key, value){
        return key+'='+value;
    },
    _constructQueryParamArrayFragment: function(key, array){
        return key+'='+array.join(',');
    },

}
